import React, {useEffect} from 'react';
import {useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";

import {RootState} from "../../redux/reducers";
import {getPageData} from "../../redux/actions";
import {Markup} from "interweave";

function PageHeader(props: {page: string}){
    return <div className='static-page-header'>
        {props.page}
    </div>
}

function Page(props: any) {
    const {page} = useParams<{page:any}>();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getPageData(page))
    }, []);
    // @ts-ignore
    const pageData = useSelector((state: RootState) => state.staticPageData)
    return <div className='static-page'>
        { pageData && pageData.page ?
            <>
                <PageHeader page={pageData.page.title} />
                <Markup content={pageData.page.body} />
            </>
        : null }

    </div>
}

export default Page;
